/**
 * Small School Galleries Lightbox
 * Each "school-group" block has its own set of 1-4 images.
 * Clicking any image opens the lightbox scoped ONLY to that school's images
 * (navigation does not cross over into other schools' photos).
 */
(function () {
  var initializedSections = {};

  window.initSchoolGroups = function (sectionId) {
    if (initializedSections[sectionId]) return;
    initializedSections[sectionId] = true;

    var wrapper = document.getElementById('SchoolGroups-' + sectionId);
    var lightbox = document.getElementById('SchoolGroupsLightbox-' + sectionId);
    if (!wrapper || !lightbox) return;

    var lightboxImage = lightbox.querySelector('[data-school-image]');
    var counter = lightbox.querySelector('[data-school-counter]');
    var btnClose = lightbox.querySelector('[data-school-close]');
    var btnPrev = lightbox.querySelector('[data-school-prev]');
    var btnNext = lightbox.querySelector('[data-school-next]');

    var currentImages = [];
    var currentIndex = 0;

    function render() {
      var data = currentImages[currentIndex];
      lightboxImage.src = data.full;
      lightboxImage.alt = data.alt;
      if (counter) {
        counter.textContent = (currentIndex + 1) + ' / ' + currentImages.length;
      }
    }

    function open(images, index) {
      currentImages = images;
      currentIndex = index;
      render();
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % currentImages.length;
      render();
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
      render();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') showNext();
      if (e.key === 'ArrowLeft') showPrev();
    }

    // Bind click handlers per group, scoping navigation to that group's own images
    var groups = wrapper.querySelectorAll('[data-group]');
    groups.forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('[data-school-item]'));
      if (!items.length) return;

      var groupImages = items.map(function (item) {
        var img = item.querySelector('img');
        return {
          full: img.getAttribute('data-full') || img.src,
          alt: img.getAttribute('alt') || ''
        };
      });

      items.forEach(function (item, index) {
        item.addEventListener('click', function () {
          open(groupImages, index);
        });
      });
    });

    btnClose.addEventListener('click', close);
    btnNext.addEventListener('click', showNext);
    btnPrev.addEventListener('click', showPrev);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    // Touch swipe support for mobile
    var touchStartX = 0;
    var touchEndX = 0;
    var SWIPE_THRESHOLD = 40;

    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) < SWIPE_THRESHOLD) return;
      if (delta < 0) {
        showNext();
      } else {
        showPrev();
      }
    }, { passive: true });
  };
})();